module.exports = __webpack_public_path__ + "img/helpdetail1.46027b2f.png";